import { useEffect } from 'react';
import { getSelectedProductDetails, getProductsByTypes, CARD_PRODUCT } from '@americanexpress/product-ducks';
import { useSelector } from 'react-redux';
import { runQualtrics, resetQualtrics } from '../utils/qualtrics';

const QualtricsConfiguration = () => {
  const {
    selectedProduct,
    cardProductsList,
  } = useSelector((state) => {
    const sp = getSelectedProductDetails(state);
    const {
      [CARD_PRODUCT]: {
        productsList,
      } = {},
    } = getProductsByTypes(state);

    return {
      selectedProduct: sp,
      cardProductsList: productsList,
    };
  });

  useEffect(() => {
    runQualtrics(selectedProduct, cardProductsList);

    return () => resetQualtrics();
  }, [selectedProduct, cardProductsList]);

  return null;
};

export default QualtricsConfiguration;
